import React, { useState, useEffect } from "react"
import Swal from "sweetalert2"
import {URL} from "../../config"

const AddProduct = ({user, token}) => {
	const [formData, setFormData] = useState({})
	const [categories, setCategories] = useState([])

	useEffect(()=>{
		fetch(`${URL}/categories`,{
			headers:{
				"x-auth-token": localStorage.getItem("token")
			}
		})
		.then(res=>res.json())
		.then(data=>{
			setCategories(data)
		})
	}, [])


	const onChangeHandler = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		})
	}


	const handleFile=(e)=>{
		// console.log(e.target.files[0])
				setFormData({
			...formData,
			image: e.target.files[0]
		})
	}


	// console.log(formData)
	const onSubmitHandler = (e) => {
		e.preventDefault()

		const product = new FormData()
		product.append("name", formData.name)
		product.append("description", formData.description)
		product.append("price", formData.price)
		product.append("image", formData.image)
		product.append("categoryId", formData.categoryId)

		fetch(`${URL}/products`, {
			method: "POST",
			body: product,
			headers : {
				
				"x-auth-token": localStorage.getItem("token")
			}
		})
		.then(res => res.json())
		.then(data => {
		// console.log(data)
			if(data.status === 200) {

				Swal.fire({
					icon: 'success',
					text: data.message
				})

				window.location.href="/"

			} else {

				Swal.fire({
					icon: 'error',
					text: "Please check input"
				})
			}
		})
	}

	return(
		<div className="addTour-background">
			<form className="container col-sm-5 mx-auto py-5" onSubmit={onSubmitHandler} encType="multipart/form-data">

				<div className="card addProduct text-white">
					<div className="card-header">
						<h3>Add A New Tour</h3>
					</div>
					<div className="card-body">
						<div className="alert" id="alert-message"></div>

						<div className="form-group">
							<label htmlFor="name">Tour Name</label>
							<input type="text" className="form-control" name="name" id="name" onChange={onChangeHandler}/>
						</div>

						<div className="form-group">
							<label htmlFor="description">Description</label>
							<textarea className="form-control" name="description" id="description" onChange={onChangeHandler}></textarea>
						</div>

						<div className="form-group">
							<label htmlFor="price">Price</label>
							<input type="number" className="form-control" name="price" id="price" onChange={onChangeHandler}/>
						</div>

						<div className="form-group pb-3">
							<label htmlFor="image">Image</label>
							<input type="file" className="form-control" name="image" id="image" onChange={handleFile}/>
						</div>

						<div className="form-group pb-3">
							<select className="form-control" name="categoryId" onChange={onChangeHandler}>
								<option disabled selected>Select Category</option>
								{ categories.map(category=>(
									<option key={category._id} value={category._id}>{category.name}</option> ))}
							</select>
						</div>
					</div>
					<div className="card-footer">
						<button className="btn btn-primary mt-auto">Add Product</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default AddProduct